var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComparison = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 16,
  x: 8,
  y: 4,
  rx: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 7,
  x: 3,
  y: 13,
  rx: 1.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 14,
  x: 13,
  y: 6,
  rx: 1.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 11,
  x: 18,
  y: 9,
  rx: 1.5
})));
export default SvgComparison;